(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.MutatingDot = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.MutatingDot = undefined;
  var _react2 = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var MutatingDot = exports.MutatingDot = function MutatingDot(svg) {
    return _react2.default.createElement("svg", {
      id: "goo-loader",
      width: svg.width,
      height: svg.height
    }, _react2.default.createElement("filter", {
      id: "fancy-goo"
    }, _react2.default.createElement("feGaussianBlur", {
      "in": "SourceGraphic",
      stdDeviation: "6",
      result: "blur"
    }), _react2.default.createElement("feColorMatrix", {
      "in": "blur",
      mode: "matrix",
      values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
      result: "goo"
    }), _react2.default.createElement("feComposite", {
      "in": "SourceGraphic",
      in2: "goo",
      operator: "atop"
    })), _react2.default.createElement("g", {
      filter: "url(#fancy-goo)"
    }, _react2.default.createElement("animateTransform", {
      id: "mainAnim",
      attributeName: "transform",
      attributeType: "XML",
      type: "rotate",
      from: "0 50 50",
      to: "359 50 50",
      dur: "1.2s",
      repeatCount: "indefinite"
    }), _react2.default.createElement("circle", {
      cx: "50%",
      cy: "40",
      r: "11"
    }, _react2.default.createElement("animate", {
      id: "cAnim1",
      attributeType: "XML",
      attributeName: "cy",
      dur: "0.6s",
      begin: "0;cAnim1.end+0.2s",
      calcMode: "spline",
      values: "40;20;40",
      keyTimes: "0;0.3;1",
      keySplines: "0.175, 0.885, 0.320, 1.5; 0.175, 0.885, 0.320, 1.5"
    })), _react2.default.createElement("circle", {
      cx: "50%",
      cy: "60",
      r: "11"
    }, _react2.default.createElement("animate", {
      id: "cAnim2",
      attributeType: "XML",
      attributeName: "cy",
      dur: "0.6s",
      begin: "0.4s;cAnim2.end+0.2s",
      calcMode: "spline",
      values: "60;80;60",
      keyTimes: "0;0.3;1",
      keySplines: "0.175, 0.885, 0.320, 1.5;0.175, 0.885, 0.320, 1.5"
    }))));
  };
});